import { render, staticRenderFns } from "./Tbody2.vue?vue&type=template&id=6623e310&scoped=true&"
import script from "./Tbody2.vue?vue&type=script&lang=js&"
export * from "./Tbody2.vue?vue&type=script&lang=js&"
import style0 from "./Tbody2.vue?vue&type=style&index=0&id=6623e310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6623e310",
  null
  
)

export default component.exports